/* eslint-disable @typescript-eslint/no-use-before-define */
import { Map } from "ol";
import { easeOut } from "ol/easing";
import { FeatureLike } from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import { unByKey } from "ol/Observable";
import { getVectorContext } from "ol/render";
import RenderEvent from "ol/render/Event";
import { Stroke, Style } from "ol/style";
import CircleStyle from "ol/style/Circle";
import { LayerTitle } from "../types/layers";
import { AtoNMapItem } from "../types/mapItems";
import { findLayerByTitle } from "./findLayerByTitle";
import { findSourceByTitle } from "./findSourceByTitle";

const totalDuration = 1500;

export function atonFaultHandler(map: Map, enabled: boolean): void {
  // Remove old listeners
  const layer = findLayerByTitle(map, LayerTitle.AtoNs);
  if (!layer) return;
  layer
    .getListeners("postrender")
    ?.forEach((l) => layer.removeEventListener("postrender", l));

  let start = Date.now();

  const feats = findSourceByTitle(map, LayerTitle.AtoNs).getFeatures();
  const faulted = feats.filter(
    (f) => (f.getProperties() as AtoNMapItem).activeFaultCount > 0,
  );
  const key = layer.on("postrender", (e: RenderEvent) =>
    animate(e, faulted, enabled),
  );
  function animate(
    event: RenderEvent,
    faultedFeats: FeatureLike[],
    en: boolean,
  ) {
    const vectorContext = getVectorContext(event);

    if (!en) {
      vectorContext.setStyle(new Style({}));
      unByKey(key);
      return;
    }
    const { frameState } = event;
    if (faultedFeats.length === 0) return;

    const elapsed = frameState.time - start;
    const elapsedRatio = elapsed / totalDuration;
    if (elapsedRatio >= 1) {
      start = Date.now();
    }
    // radius loops from min to max to min.
    const radiusMin = 10;
    const radiusMax = 35;
    // const midpoint = 0.5;
    const midpoint = 1; // Currently goes to one direction only
    const radiusRange = radiusMax - radiusMin;
    const midpointRatio =
      elapsedRatio <= midpoint
        ? elapsedRatio / midpoint
        : 1 + (1 - elapsedRatio / midpoint);
    const calculatedRadius = radiusRange * easeOut(midpointRatio) + radiusMin;
    // console.log(
    //   `Ratio: ${elapsedRatio}, MidpointRatio: ${midpointRatio}, Radius: ${calculatedRadius}`,
    // );
    const radius = calculatedRadius;

    const opacity = 1 - easeOut(midpointRatio);

    const style = new Style({
      image: new CircleStyle({
        radius,
        stroke: new Stroke({
          color: `rgba(255, 0, 0, ${opacity})`,
          width: 0.5 + opacity,
        }),
      }),
    });
    vectorContext.setStyle(style);

    faultedFeats.forEach((f) => {
      vectorContext.drawGeometry((f.getGeometry() as Geometry).clone());
    });

    // tell OpenLayers to continue postrender animation
    map.render();
  }
}
